import { Component, inject, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { MDBBootstrapModulesPro } from 'ng-uikit-pro-standard';
import { FaDirectiveEnum } from '../../../../models/enums/fa-directive.enum';
import { BaryIconComponent } from '../bary-icon/bary-icon.component';

@Component({
  selector: 'jhi-bary-title',
  standalone: true,
  imports: [MDBBootstrapModulesPro, CommonModule, BaryIconComponent],
  templateUrl: './bary-title.component.html',
  styleUrls: ['./bary-title.component.scss'],
})
export class BaryTitleComponent {
  readonly #translateService = inject(TranslateService);

  @Input() tooltip?: string;
  @Input() title?: string;
  @Input() titleKey!: string;
  @Input() titleClass = 'bold text-dark';
  @Input() invalid = false;

  protected readonly FAS = FaDirectiveEnum.FAS;

  get _title(): string {
    return (this.titleKey ? this.#translateService.instant(this.titleKey) : this.title) as string;
  }
}
